<template>
<div class="orderBatch max-width">

	<!-- 产品图片 -->
	<div class='ob_image'>
		<img class='ob_image_img' src='@/assets/banner/small_banner_02.png' />
	</div>

	<div class='ob_content'>
		<!-- 选择文件按钮 -->
		<div class='ob_button no-copy'>
			<img class='ob_but_icon' src='@/assets/icon/orderBatch_upload.png' />
			<div class='color-prompt'>
				<div class='font-24 fontweight-bo'>批量上传文件</div>
				<div class='font-14'>目前仅支持标准信封产品，文件名命名不规范将无法使用批量下单</div>
			</div>
			<input class='ob_but_input' type='file' multiple='multiple' ref='vimc' @change='func_multipleChange' />
		</div>
		<img class='ob_demoImg' src='@/assets/banner/orderBatch-demo-02.jpg' mode='widthFix'/>
	</div>

	<!-- 上传的文件列表 -->
	<!-- <div v-if='ob_list && ob_list.length > 0' class='ob_model'> -->
	<div class='ob_model'>
		<div class='ob_mod_line ob_mod_line_title'>
			<div class='ob_mod_li_div ob_mod_li_filename'>上传文件</div>
			<!-- <div class='ob_mod_li_div ob_mod_li_product'>产品规格</div> -->
			<div class='ob_mod_li_div ob_mod_li_price'>订单价格</div>
			<div class='ob_mod_li_div ob_mod_li_status'>状态</div>
		</div>
		<template v-for='(item,index) in ob_list'>
			<div :key='item.id' 
				class='ob_mod_line ob_mod_line_hover' 
				>
				<div v-if="item.uploadStatus !== -1" class='ob_mod_li_div ob_mod_li_filename'>{{item.name_modify ? item.name_modify : item.name}}</div>
				<input v-if="item.uploadStatus === -1" class='ob_mod_li_div ob_mod_li_filename' v-model='item.name_modify' />
				<!-- <div class='ob_mod_li_div ob_mod_li_product'>{{item.g_info&&item.g_info.Content ? item.g_info.Content : ''}}</div> -->
				<div class='ob_mod_li_div ob_mod_li_price'>{{item.g_info&&item.g_info.Price ? '￥'+item.g_info.Price : ''}}</div>
				<div :class="{'ob_mod_li_div ob_mod_li_status':true, 'color':item.uploadStatus===1||item.uploadStatus===2, 'ob_mod_li_status_error':item.uploadStatus===-1||item.uploadStatus===3}">
					<span v-if="item.uploadStatus === 0">
						等待上传
					</span>
					<span v-else-if="item.uploadStatus === 1">
						上传中
					</span>
					<span v-else-if="item.uploadStatus === 2">
						上传成功-等待识别
					</span>
					<span v-else-if="item.uploadStatus === 3">
						上传失败
					</span>
					<span v-else-if="item.uploadStatus === -1">
						文件无法识别
						<span class='ob_mod_li_status_btn ob_mod_li_status_btn_save' 
							  :data-index='index' 
							   data-opera='save' 
							  @click='func_lineBtnOpera' 
							  >保存
						</span>
						<span class='ob_mod_li_status_btn ob_mod_li_status_btn_delete' 
							  :data-index='index' 
							   data-opera='delete' 
							  @click='func_lineBtnOpera' 
							  >删除
						</span>
					</span>
					<span v-else-if="item.uploadStatus === -2">
						文件识别成功
					</span>
					<span v-else>
						状态异常
					</span>
				</div>
			</div>
		</template>
		<div class='ob_mod_btn no-copy'>
			<div v-if="allIsOkay" class='ob_mod_li_btn_count'>所有订单识别成功, 一共{{ob_list.length}}个订单, 金额￥{{totalPrice}}</div>
			<div class='ob_mod_li_btn_view bgcolor-gradient-right fontweight-bo' @click='func_saveTrolley'>保存到购物车</div>
		</div>
	</div>

	<v-fileUpload ref='vflu'></v-fileUpload>
</div>
</template>

<script>
import fileUpload from '@/components/fileUpload/fileUpload';
import Axios from 'axios';
import {req_offer_batch} from '@/services/product'

export default {
	name: 'orderBatch',
	components: {
		'v-fileUpload': fileUpload,
	},
	data() {
		return {
			ob_list: [],
			/* 
			uploadStatus: 
				 0: 未上传,
				 1: 上传中,
				 2: 上传成功,
				 3: 上传失败,
				-1: 文件识别失败
				-2: 文件识别成功
			*/
			allIsOkay: false,
			totalPrice: 0,
		}
	},
	watch: {
		ob_list: function(newValue, oldValue) {
			let count = 0;
			let totalPrice = 0;
			for (let i in newValue) {
				if (newValue[i]['uploadStatus'] === -2) {
					count += 1;
					totalPrice += parseFloat(newValue[i]['g_info']['Price']);
				}
			}
			if (count === this.ob_list.length) {
				this.totalPrice = totalPrice;
				this.allIsOkay = true;
			} else {
				this.totalPrice = 0;
				this.allIsOkay = false;
			}
		}
	},
	methods: {
		// 文件识别失败-操作按钮
		async func_lineBtnOpera(event) {
			const index = event.currentTarget.dataset.index;
			const opera = event.currentTarget.dataset.opera;
			switch (opera) {
				case 'save': {
					this.$parent.loadingChange(true, '识别文件中....');
					const result = await this.func_identifyFile(this.ob_list[index]['name_modify']);
					this.$parent.loadingChange(false);
					if (result) {
						// 识别成功
						this.func_conversion(this.ob_list[index], index, -2);
						this.ob_list[index]['g_info'] = result;
						this.$parent.msgChange('warning', '识别成功', '');
					} else {
						// 识别失败
						this.$parent.msgChange('warning', '识别失败', '');
					}
					break;
				}
				case 'delete': {
					this.$parent.confirmChange('information', '确定删除？', () => {
						setTimeout(() => {
							this.ob_list.splice(index, 1);
						}, 300)
					}, () => {}, {yes:'确定', no:'取消'});
					break;
				}
			}
		},
		// 按钮-保存到购物车
		func_saveTrolley() {
			let count = 0;
			for (let i = 0; i < this.ob_list.length; i += 1) {
				// 只添加最终文件可以识别的
				if (this.ob_list[i]['uploadStatus'] === -2) {
					this.func_trolleyInsert(this.ob_list[i]);
					// 从当前页列表中删除
					this.ob_list.splice(i, 1);
					count += 1;
					i-=1;
				}
			}
			if (count > 0) {
				this.$parent.msgChange('warning', count+'个文件保存到购物车成功.', '');
				this.$parent.func_tabbar_trolley();
				if (this.allIsOkay) {
					this.$router.push({
						name: 'trolley'
					});
				}
			}
		},
		// 检查文件后缀名并返回文件数组
		func_multipleCheck(temp) {
			let files = [];
			for (let i in temp) {
				if (temp[i].constructor['name'] === 'File') {
					temp[i].fileSize = (temp[i]['size']/1024).toFixed(2);
					files.push(temp[i]);
				}
			}

			const file_type = ['jpg', 'png', 'gif', 'jpeg', 'cdr', 'ai', 'zip', 'rar', 'tiff', 'eps', 'pdf']
			for (let j in files) {
				files[j]['uploadStatus'] = 0;
				const file = files[j];
				let errorFile = false;
				for (let i in file_type) {
					if (file.name.endsWith(file_type[i]) || file.name.endsWith(file_type[i].toLocaleUpperCase())) {
						errorFile = (file.name + '');
						break;
					}
				}
				if (!errorFile && errorFile.constructor['name']==='Boolean') {
					this.$parent.confirmChange('warning', '当前文件列表中, 存在文件类型不正确的文件, 请检查后重新选择。(错误文件:'+file.name+')', () => {}, () => {}, {yes:'知道了', no:''});
					return false;
				}
			}
			return files;
		},
		async func_multipleChange(event) {
			const files = this.func_multipleCheck(this.$refs.vimc.files);
			if (!files) {
				return;
			}

			this.ob_list = files;
			/* 初始定义文件状态 */
			for (let i = 0; i < this.ob_list.length; i += 1) { this.func_conversion(this.ob_list[i], i, 0); }
			// 存储执行失败的文件
			let failArr = [];
			/* 上传文件 */
			for (let i = 0; i < this.ob_list.length; i += 1) {
				// 1) 当前文件状态变更-上传中
				this.func_conversion(this.ob_list[i], i, 1);
				// 2) 控制上传进度显示
				this.$refs.vflu.vflu_Change(this.ob_list[i], '正在上传第' + (parseInt(i)+1) + '个文件');
				// 3) 实际调用接口上传文件
				const result = await this.func_uploadIng(this.ob_list[i]);
				if (result) {
					// 上传成功
					this.func_conversion(this.ob_list[i], i, 2);
					this.ob_list[i]['g_uploadInfo'] = result;
				} else {
					// 上传失败
					this.func_conversion(this.ob_list[i], i, 3);
					failArr.push(this.ob_list[i]);
				}
			}
			// 关闭上传进度显示
			this.$refs.vflu.vflu_close();
			if (failArr.length > 0) {
				this.$parent.msgChange('warning', failArr.length+'个文件上传失败, 可在下方列表查看.', '');
			}

			failArr = [];
			/* 识别文件 */
			this.$parent.loadingChange(true, '识别文件中....');
			for (let i = 0; i < this.ob_list.length; i += 1) {
				// 仅识别上传成功的文件
				if (!this.ob_list[i]['g_uploadInfo']) continue;
				// const result = await req_offer_batch(this.ob_list[i]['name']);
				const result = await this.func_identifyFile(this.ob_list[i]['name']);
				if (result) {
					// 识别成功
					this.func_conversion(this.ob_list[i], i, -2);
					this.ob_list[i]['g_info'] = result;
				} else {
					// 识别失败
					// 设置二次修改文件名
					this.ob_list[i]['name_modify'] = this.ob_list[i]['name'];
					this.func_conversion(this.ob_list[i], i, -1);
					failArr.push(this.ob_list[i]);
				}
			}
			this.$parent.loadingChange(false);
			if (failArr.length > 0) {
				this.$parent.confirmChange('warning', failArr.length+'个文件识别失败, 可在下方列表中修改文件名, 保存后重新识别', () => {}, () => {}, {yes:'知道了', no:''});
			} else {
				this.$parent.confirmChange('warning', '文件上传识别完成, 请在下方确认后, 保存到购物车', () => {}, () => {}, {yes:'知道了', no:''});
			}
		},
		func_conversion(item, index, uploadStatus) {
			item['uploadStatus'] = uploadStatus;
			const temp = item;
			this.ob_list.splice(index, 1);
			this.ob_list.splice(index, 0, temp);
		},
		// 请求执行文件上传
		async func_uploadIng(file) {
			return new Promise((resolve, reject) => {
				//判断文件所属产品类型
				let file_belong = 'pbbgj';
				let formData = new FormData();
				formData.append('name', 'Alax');
				formData.append('imagefile', file);
				formData.append('fileFloatType', file_belong);
				const config = {
					headers: { 'Content-Type': 'multipart/form-data' },
					onUploadProgress: (e) => {
						if (e.lengthComputable) {
							const rate = e.loaded / e.total;  //已上传的比例
							if (rate < 1) {
								const proging = (rate *100).toFixed(2);
								this.$refs.vflu.vflu_uploadIng(proging);
							}
						}
					}
				};

				const url = 'http://www.yin2015.com:8080/vip/newattachmgr/upload';
				Axios.post(url, formData, config)
				.then((data) => {
					const json = data.data;
					if (json.statusCode === 200) {
						//保存接口返回的文件路径、文件名-$parent
							const temp = json.forwardUrl.split('&&');
						this.$refs.vflu.vflu_uploadIng('100.00');
						// this.func_trolleyInsert(file.name, temp[0], temp[1], file.fileSize);
						resolve(temp);
					} else {
						this.$refs.vflu.vflu_uploadIng(-1);
						resolve(false);
					}
				})
			})
		},
		// 请求识别文件
		func_identifyFile(name) {
			return new Promise(async (resolve, reject) => {
				const result = await req_offer_batch(name);
				if (result.success) {
					resolve(result.data);
				} else {
					resolve(false);
				}
			})
		},
		//加入购物车
		func_trolleyInsert(params) {
			const file_type = ['jpg', 'png', 'gif', 'jpeg', 'cdr', 'ai', 'zip', 'rar', 'tiff', 'eps', 'pdf']
			for (let i in file_type) {
				if (!params['g_info']['Memo']) {
					break;
				}
				if (params['g_info']['Memo'].endsWith(file_type[i]) || params['g_info']['Memo'].endsWith(file_type[i].toLocaleUpperCase())) {
					const len = file_type[i].length;
					const str = params['g_info']['Memo']
					params['g_info']['Memo'] = str.substring(0, str.length-len-1);
					break;
				}
			}
			// 1)
			let trollerList = this.STORAGE.get('g_trollerList');
			if (!trollerList || trollerList.length < 1) {
				trollerList = [];
			}
			// 2)
			let proName = '标准信封';
			trollerList.push({
				uploadedfilenameold: params['name'],
				uploadedfilenameold_modify: params['name_modify'] ? params['name_modify'] : '',
				uploadedfilepath: params['g_uploadInfo'][0],
				uploadedfilename: params['g_uploadInfo'][1],
				uploadedfilesize: params['fileSize'],
				bid: params['g_info']['bid'],
				kuanshu: params['g_info']['pinzhong'],
				remark: (params['g_info']['Memo'] ? params['g_info']['Memo'] : ''),
				offerInfoString: params['g_info']['Content'],
				offerInfoPrice: params['g_info']['Price'],
				productName: proName,
			})
			// 3)
			this.STORAGE.set('g_trollerList', trollerList);
		},
	},
	mounted() {
	},
}
</script>
<style src='@/style/orderBatch.css' scoped></style>



// WEBPACK FOOTER //
// src/pages/OrderBatch.vue